import { render, staticRenderFns } from "./PurchaseDialog_Invoice.vue?vue&type=template&id=1f32a497"
import script from "./PurchaseDialog_Invoice.vue?vue&type=script&lang=js"
export * from "./PurchaseDialog_Invoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports